import { render, staticRenderFns } from "./TambahAtributJenisBarang.vue?vue&type=template&id=1a95c876&scoped=true&"
import script from "./TambahAtributJenisBarang.vue?vue&type=script&lang=js&"
export * from "./TambahAtributJenisBarang.vue?vue&type=script&lang=js&"
import style0 from "./TambahAtributJenisBarang.vue?vue&type=style&index=0&id=1a95c876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a95c876",
  null
  
)

export default component.exports